/* eslint-disable no-param-reassign */

import * as types from './mutationTypes';

export default {
  [types.START_FETCH_STOCKS](state, { filters, fetchId }) {
    if (filters) {
      state.filters = {
        txType: [],
        districts: [],
        ...filters,
      };
    }
    state.fetchId = fetchId;
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.items = [];
  },

  [types.SET_FETCHED_STOCKS](state, { stocks: { count, stocks }, fetchId }) {
    if (fetchId === state.fetchId) {
      state.fetchId = null;
      state.isFetching = false;
      state.isFetched = true;
      state.fetchError = null;
      state.totalCount = count;
      state.items = stocks;
    }
  },

  [types.FETCH_STOCKS_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.fetchError = error;
  },

  [types.START_FETCH_MORE_STOCKS](state) {
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
  },

  [types.PREPEND_FETCHED_STOCKS](state, { stocks }) {
    state.isFetching = false;
    state.isFetched = true;
    state.items = stocks.concat(state.items);
  },

  [types.APPEND_FETCHED_STOCKS](state, { stocks }) {
    state.isFetching = false;
    state.isFetched = true;
    state.items = state.items.concat(stocks);
  },

  [types.SET_FILTER](state, filter) {
    let filters = { ...state.filters, ...filter };
    if (filters.txType.length > 0 && !filters.txType.includes('B')) {
      if (filters.txType.length > 0 && !filters.txType.includes('S')) {
        // Remove sell related filters
        const {
          sellMin,
          sellMax,
          ftSellMin,
          ftSellMax,
          ...newFilters
        } = filters;
        filters = newFilters;
      }
      if (filters.txType.length > 0 && !filters.txType.includes('L')) {
        // Remove lease related filters
        const {
          rentMin,
          rentMax,
          ftRentMin,
          ftRentMax,
          ...newFilters
        } = filters;
        filters = newFilters;
      }
    }
    state.filters = filters;
  },

  [types.UNSET_FILTER](state, filterKey) {
    const filters = {
      ...state.filters,
    };
    delete filters[filterKey];
    state.filters = filters;
  },

  [types.CHANGE_SORTING](state, { field, direction }) {
    state.sorting = {
      field,
      direction,
    };
  },

  [types.HIGHLIGHT_STOCK](state, { stock, field }) {
    state.highlighted.stock = stock;
    state.highlighted.field = field;
    state.sorting = {
      field,
      direction: 'asc',
    };
  },

  [types.SET_RECENT_VISITED](state, payload) {
    state.recentVisited = payload;
  },

  [types.SET_FAVORITE](state, payload) {
    state.favorite = payload;
  },

  [types.SET_FAVORITE_2](state, payload) {
    state.favorite2 = payload;
  },

  [types.SET_FETCHED_RECENT_VISITED](state, payload) {
    state.fetchedRecentVisited = payload;
  },

  [types.SET_FETCHED_FAVORITE](state, payload) {
    state.fetchedFavorite = payload;
  },

  [types.SET_AUTO_SEARCH](state, value) {
    state.autoSearch = value;
  },

  [types.SET_PAGE_SIZE](state, value) {
    state.pageSize = value;
  },

  [types.START_FETCH_PAGINATED_STOCKS](state, { fetchId }) {
    state.fetchId = fetchId;
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.items = [];
  },

  [types.SET_FETCHED_PAGINATED_STOCKS](
    state,
    { stocks: { count, stocks }, fetchId },
  ) {
    if (fetchId === state.fetchId) {
      state.fetchId = null;
      state.isFetching = false;
      state.isFetched = true;
      state.fetchError = null;
      state.totalCount = count;
      state.items = stocks;
    }
  },
};
